/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

const formatDate = date => {
   if (!date) return null
   const d = new Date(date)
   const year = d.getFullYear()
   const month = String(d.getMonth() + 1).padStart(2, '0')
   const day = String(d.getDate()).padStart(2, '0')
   return `${year}-${month}-${day}`
}

export default {
   namespaced: true,
   state: {
      items: [],
      item: {},
      countAll: 0,
   },
   getters: {},
   actions: {
      getData({ commit, rootState }, param) {
         rootState.isLoading = true
         const params = {}
         if (param && param.filter) {
            if (param.filter.tanggal_awal) params.tanggal_awal = formatDate(param.filter.tanggal_awal)
            if (param.filter.tanggal_akhir) params.tanggal_akhir = formatDate(param.filter.tanggal_akhir)
            if (param.filter.status !== null && param.filter.status !== undefined) params.status = param.filter.status
         }
         if (param && param.search) params.search = param.search
         if (param && param.page) params.page = param.page
         if (param && param.perPage) params.perPage = param.perPage
         return axios.get(`${baseURL}pengaduan`, { params }).then(
            response => {
               commit('SET_DATA', response.data.rows)
               commit('SET_COUNT', response.data.totalRecords)
               rootState.isLoading = false
               return Promise.resolve(response.data)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      getItem({ commit, rootState }, id) {
         rootState.isLoading = true
         return axios.get(`${baseURL}pengaduan/${id}`).then(
            response => {
               rootState.isLoading = false
               commit('SET_ITEM', response.data.item)
               return Promise.resolve(response.data.item)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      postItem({ rootState }, data) {
         rootState.isLoading = true
         return axios.post(`${baseURL}pengaduan`, data).then(
            () => {
               rootState.isLoading = false
               return Promise.resolve()
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      updateItem({ rootState }, data) {
         rootState.isLoading = true
         return axios.put(`${baseURL}pengaduan/${data.id}`, data).then(
            () => {
               rootState.isLoading = false
               return Promise.resolve()
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      deleteItem({ rootState }, id) {
         rootState.isLoading = true
         return axios.delete(`${baseURL}pengaduan/${id}`).then(
            () => {
               rootState.isLoading = false
               return Promise.resolve()
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      cetakPengaduan({ rootState }, params) {
         rootState.isLoading = true
         return axios
            .get(`${baseURL}pengaduan/cetak`, {
               params,
               responseType: 'blob',
            })
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response)
               },
               error => {
                  rootState.isLoading = false
                  return Promise.reject(error)
               },
            )
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.items = data
      },
      SET_ITEM(state, data) {
         state.item = data
      },
      SET_COUNT(state, data) {
         state.countAll = data
      },
   },
}
